export default __webpack_public_path__ + "static/media/destructorP.271fe498.webp";